export const stringMapDefault = {
    topArrow: "Scroll Up",
    bottomArrow: "Scroll Down",
    rightArrow: "Scroll Right",
    leftArrow: "Scroll Left",
    loading: "Loading"
};
